import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, switchMap, tap } from 'rxjs';
import { GlobalComponent } from 'src/app/global-component';
import { MyfileApiService } from '../myfile-api.service';
import { SearchResultModel } from '../../models/query/search-result-model';
import { BaseListService } from './base-list.service';
import { CalendarEventModel } from '../../models/calendar/calendar.model';
import { CalendarEventSearchModel } from '../../models/calendar/calendar-search.model';
import { AuthMyfileService } from '../auth.myfile.service';

@Injectable({
  providedIn: 'root'
})
export class CalendarListService extends BaseListService {

  defaultCalendarListState: CalendarEventSearchModel = {
    sortColumnDirective: '',
    sortDirectionDirective: 'desc',
    pageSize: GlobalComponent.defaultPagingInfo.exportPageSize,
    pageIndex: 0,
    startIndex: 0,
    sortColumn: '',
    sortDirection: 'desc',
    searchTerm: undefined,
    attendeeSearch: { emails: [] },
    to: undefined,
    from: undefined
  };

  private _resultItems$ = new BehaviorSubject<CalendarEventModel[]>([]);
  protected override _state: CalendarEventSearchModel = { ...this.defaultCalendarListState };

  constructor(
    private myFileApiService: MyfileApiService,
    private authMyFileService: AuthMyfileService
  ) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe((result: any) => {
      this._resultItems$.next(result.items);
      this._total$.next(result.count);
    });
  }

  get resultItems$() { return this._resultItems$.asObservable(); }
  get rangeDate() { return this._state.rangeDate; };
  get to() { return this._state.to; };

  set createdById(createdById: any) { this._state.createdById = createdById }
  set attendeeSearch(attendeeSearchEmails: string[]) { this._state.attendeeSearch.emails = attendeeSearchEmails; this._search$.next(); }

  set to(to: string | undefined) { this._setNoSearch({ to }) }
  set from(from: string | undefined) { this._setNoSearch({ from }) }

  set sourceId(sourceId: string | undefined) { this._setNoSearch({ sourceId }) }
  set invoiceId(invoiceId: string | undefined) { this._setNoSearch({ invoiceId }) }

  protected _search(): Observable<SearchResultModel<CalendarEventModel> | boolean | undefined> {
    this._state.createdById = this.authMyFileService.currentUserContextValue?.id;
    if (this._state.attendeeSearch?.emails.length == 0) {
      this._state.attendeeSearch.emails.push(this.authMyFileService.currentUserContextValue?.email!);
    }


    this.validateStartIndex();
    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.myFileApiService.getCalendars(this._state);
  }

  updateDate() {
    if (this._state.to && this._state.from && (this._state.to.getTime() == this._state.from.getTime())) {
      this._state.to = new Date(this._state.to).setDate(this._state.to.getDate() + 1);
      this._state.to = new Date(this._state.to).toISOString();
      this._state.from = new Date(this._state.from).toISOString();
    }
    this._search$.next();
  }

  override clearListService(): void {
    this._state.attendeeSearch.emails = [];
    this._state = { ...this.defaultCalendarListState };
    this._resultItems$.next(new Array<CalendarEventModel>());
    this._total$.next(0);
  }
}
